import axios from "axios";

export const APILocal = axios.create({
    baseURL: "http://localhost:2121/",
  })  